import React, { useState, useEffect, useCallback, FC, ChangeEvent, useRef } from 'react'
import { NewButton, Item, AutocompleteInput, NotificationType, User } from 'prace-common-components'
import { $Container, $ModalContainer, $Grid } from './styles'
import { ChangeApplicantModalProps } from './types'
import Grid from '@material-ui/core/Grid'
import { useSearchUsersMutation } from 'store/api/users'
import { useAppDispatch } from 'store/hooks'

export const ChangeApplicantModal: FC<ChangeApplicantModalProps> = ({
  handleChangeApplicant,
  handleCancel,
  applicationId,
  loading,
}) => {
  const dispatch = useAppDispatch()

  const [userItem, setUserItem] = useState<Item>()
  const searchTimer = useRef<number>()
  const [userSuggestions, setUserSuggestions] = useState<User[]>([])
  const [searchUsers] = useSearchUsersMutation()

  const getUsers = useCallback(async (search = '') => {
    try {
      const data = await searchUsers({ 
        search,
        roles: [],
        excludeCCRs: true,
        page: 0,
        pageSize: 20,
      }).unwrap()
      setUserSuggestions(data.users || [])
    } catch (err) {
      console.log(err)
    }
  }, [searchUsers])

  useEffect(() => {
    getUsers('')
  }, [getUsers])

  const onInputChange = (_: any, value: string) => {
    clearTimeout(searchTimer.current)
    try {
      searchTimer.current = window.setTimeout(async () => {
        await getUsers(value)
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  const changeApplicant = () => {
    if(!userItem) {
      dispatch({ type: 'notification', payload: { type: NotificationType.error, msg: 'Please choose a user to be the new applicant' } })
      return
    }

    handleChangeApplicant(applicationId, Number(userItem?.value || 0))
  }

  const options: Item[] = userSuggestions.map((suggestion) => ({
    label: `${suggestion.firstName || ''} ${suggestion.lastName || ''} - ${suggestion.email || ''}`,
    value: suggestion.id,
  }))

  return (
    <$ModalContainer>
      <>
        <$Grid container>
          <Grid item xs={12}>
            <AutocompleteInput
              title='User search'
              name='assign'
              required
              items={options}
              value={userItem}
              onChange={(_: ChangeEvent<unknown>, user: unknown) => {
                setUserItem(user as Item)
              }}
              onInputChange={onInputChange}
            />
          </Grid>
        </$Grid>
        <$Container container justifyContent='space-between'>
          <Grid item xs={3}>
            <NewButton loading={loading} onClick={changeApplicant}>Change Applicant</NewButton>
          </Grid>
          <Grid item xs container justifyContent='flex-end'>
            <NewButton disabled={loading} variant='outlined' onClick={handleCancel}>Cancel</NewButton>
          </Grid>
        </$Container>
      </>
    </$ModalContainer>
  )
}
